import * as React from 'react';

import {SelectPickerGeneric} from 'shells/select-picker-generic/select-picker-generic';
import {TextField} from 'shells/textfield/textfield';

import type {DueDateUnit} from 'nutshell-graphql-types';
import type {MeetingFragment_minNotice as MinNotice, TimespanInput} from 'nutshell-graphql-types';

import styles from './advanced-options.module.css';

const MINIMUM_NOTICE_OPTIONS = [
    {label: 'Minutes', value: 'mm'},
    {label: 'Hours', value: 'HH'},
    {label: 'Days', value: 'dd'},
];

type Props = {
    minNotice: MinNotice | null | undefined;
    onSave: (minNotice: TimespanInput) => void;
    setSavingToastKey: (arg1: string) => void;
};

export function MinimumNotice(props: Props) {
    const [minNoticeTimespan, setMinNoticeTimespan] = React.useState<number | null | undefined>(
        props.minNotice && props.minNotice.timespan
    );
    const [minNoticeUnit, setMinNoticeUnit] = React.useState<DueDateUnit | null | undefined>(
        props.minNotice && props.minNotice.unit
    );

    const onSave = (unit?: DueDateUnit | null) => {
        props.setSavingToastKey('minimum-notice');
        if (minNoticeTimespan && unit)
            props.onSave({
                timespan: minNoticeTimespan,
                unit: unit,
            });
    };

    return (
        <div className={styles['minimum-notice']}>
            <TextField
                // @ts-expect-error
                name='meeting-notice-value'
                placeholder='0'
                type='number'
                min='0'
                max='365'
                selectOnFocus={true}
                value={minNoticeTimespan ? minNoticeTimespan.toString() : ''}
                onBlur={() => onSave(minNoticeUnit)}
                onChange={(timespan) => {
                    const val = parseInt(timespan);
                    // Validate input - only numbers allowed
                    if (typeof val === 'number') {
                        setMinNoticeTimespan(val ? val : 0);
                    }
                }}
                className={styles['minimum-notice-input']}
            />
            <div className={styles['minimum-notice-select']}>
                <SelectPickerGeneric
                    placeholder='Minimum notice units'
                    options={MINIMUM_NOTICE_OPTIONS}
                    value={MINIMUM_NOTICE_OPTIONS.find((option) => option.value === minNoticeUnit)}
                    // @ts-expect-error
                    onChange={(unit) => {
                        setMinNoticeUnit(unit.value);
                        onSave(unit.value);
                    }}
                />
            </div>
        </div>
    );
}
